import { useEffect, useState } from 'react'

import {
  areUrlsAllowed,
  onConsentChanged,
  waitForOneTrustSDK,
} from 'utils/onetrust'

import useDidMount from './use-did-mount'

const useUrlsConsent = (urls: string[]) => {
  const [areAllowed, setAreAllowed] = useState(areUrlsAllowed(urls))

  useDidMount(async () => {
    try {
      await waitForOneTrustSDK()
      setAreAllowed(areUrlsAllowed(urls))
    } catch {
      // Fail silently
    }
  })

  useEffect(() => {
    return onConsentChanged(() => {
      setAreAllowed(areUrlsAllowed(urls))
    })
  }, [urls])

  return areAllowed
}

export default useUrlsConsent
